<template>
    <v-dialog v-model="isOpen" :max-width="dialogMaxWidth">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"><img
                    src="/images/common/close.png" :style="dialogCloseBtnStyle" /></div>
        </div>
        <div class="dialogBase dialogGet" :style="getBgStyle">
            <div class="stars">
                <span class="s"></span>
                <span class="s"></span>
                <span class="m"></span>
                <span class="m"></span>
                <span class="l"></span>
                <span class="l"></span>
                <span class="l"></span>
                <span class="l"></span>
            </div>
            <div class="ma-5 text-center">
                <v-btn class="btn_blue" v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"
                    :style="dialogNextBtnStyle">
                    写真撮影に進む
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>
<style scoped>
.dialogGet {
    background-color: white;
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
    animation: back-anim 0.5s 0s 1;
}

@keyframes back-anim {
    0% {}

    30% {
        transform: scale(-1, 1);
    }

    100% {}
}

.dialogGet::before {
    content: '';
    display: block;
    padding-top: 130%;
}

.btn_blue {
    color: #FFFFFF !important;
    background-color: #0F9DE8 !important;
    box-shadow: 4px 3px #096291;
    border-radius: 100vh;
    width: 80%;
    height: 2.3em !important;
    padding-top: min(1vw, 3px) !important;
    font-size: min(5vw, 20px) !important;
    font-weight: bold !important;
}

.btn_blue:disabled {
    box-shadow: 4px 3px #999999;
}

.stars {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.stars span {
    position: relative;
    /* opacity: 0; */
}

.stars span:before {
    content: "";
    position: absolute;
    background-position: top;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(@/static/images/star.png);
}

.stars span.s:before {
    width: 4.5vw;
    height: 4.5vw;
}

.stars span.m:before {
    width: 5.5vw;
    height: 5.5vw;
}

.stars span.l:before {
    width: 7vw;
    height: 7vw;
}

.stars span:nth-child(1) {
    left: 18%;
    top: 10%;
    animation: star-anim 12s -9s infinite;
}

.stars span:nth-child(2) {
    left: 9%;
    top: 89%;
    animation: star-anim 8s 2s infinite;
}

.stars span:nth-child(3) {
    left: 85%;
    top: 35%;
    animation: star-anim 12s -6s infinite;
}

.stars span:nth-child(4) {
    left: 6%;
    top: 40%;
    animation: star-anim 9s 2s infinite;
}

.stars span:nth-child(5) {
    left: 10%;
    top: 15%;
    animation: star-anim 7s 0s infinite;
}

.stars span:nth-child(6) {
    left: 80%;
    top: 30%;
    animation: star-anim 8s 4s infinite;
}

.stars span:nth-child(7) {
    left: 73%;
    top: 80%;
    animation: star-anim 6s 3s infinite;
}

.stars span:nth-child(8) {
    left: 5%;
    top: 82%;
    animation: star-anim 8s -4s infinite;
}

/*アニメーションキーフレーム*/
@keyframes star-anim {
    0% {
        opacity: 0;
    }

    5% {
        opacity: 1;
    }

    10% {
        opacity: 0;
    }

    55% {
        opacity: 0;
    }

    60% {
        opacity: 1;
    }

    95% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
        getBgStyle: "",
        dialogMaxWidth: 400,
        dialogCloseBtnStyle: "",
        dialogNextBtnStyle: ""
    }),
    props: {
        data: {
            type: Object,
            default: {},
            required: true
        }
    },
    created: function () {
        if (this.dialogMaxWidth * 1.6 > window.innerHeight) {
            this.dialogMaxWidth = window.innerHeight / 1.7;
            this.dialogCloseBtnStyle = "width:min(8vw, 48px) !important";
            this.dialogNextBtnStyle = "font-size:min(4vw, 16px) !important";
        }

        this.updateData();

    },
    destroyed: function () {
    },
    methods: {
        updateData() {
            if (this.data) {
                this.getBgStyle = "background-image:url(/images/puzzle/comp_" + this.data.frame + ".png)";
            }
        }
    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close', this.data);
            }
        },
        data(newVal) {
            // console.log("getWinChange", newVal);
            this.updateData();
        }
    }
}
</script>